
  var _styles = {
  "free-order-received-card__container": {
    "width": "9.36rem",
    "height": "2.4rem",
    "borderRadius": "0.32rem",
    "position": "relative",
    "overflow": "hidden"
  },
  "free-order-received-card__background": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "1.84rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden",
    "zIndex": 0
  },
  "free-order-received-card__wrapper": {
    "position": "relative",
    "zIndex": 1,
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "width": "9.36rem",
    "height": "2.4rem"
  },
  "free-order-received-card__left": {
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "2.4rem",
    "width": "2.86667rem",
    "position": "relative",
    "overflow": "visible"
  },
  "free-order-received-card__badge": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "height": "0.45333rem",
    "paddingTop": 0,
    "paddingRight": "0.17333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.17333rem",
    "borderRadius": "0.29333rem 0 0.21333rem 0",
    "backgroundColor": "rgb(255,241,240)",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "free-order-received-card__badge-text": {
    "fontWeight": "400",
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem"
  },
  "free-order-received-card__amount-wrapper": {
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center",
    "marginTop": "0.16rem",
    "overflow": "visible"
  },
  "free-order-received-card__amount-prefix": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem"
  },
  "free-order-received-card__amount-content": {
    "color": "rgb(255,45,25)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "0.77333rem",
    "lineHeight": "0.96rem",
    "overflow": "visible"
  },
  "free-order-received-card__expire-text": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "fontWeight": "400",
    "textAlign": "center"
  },
  "free-order-received-card__right": {
    "flex": 1,
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "center",
    "paddingRight": "0.32rem"
  },
  "free-order-received-card__title-wrapper": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "maxWidth": "6.53333rem"
  },
  "free-order-received-card__title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "maxWidth": "6.53333rem"
  },
  "free-order-received-card__biz-line-wrapper": {
    "marginTop": "0.05333rem",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "free-order-received-card__biz-line-text": {
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "maxWidth": "5.86667rem"
  },
  "free-order-received-card__biz-line-icon-btn": {
    "width": "0.37333rem",
    "height": "0.37333rem",
    "marginLeft": "0.02667rem",
    "flexShrink": 0,
    "justifyContent": "center",
    "alignItems": "center"
  },
  "free-order-received-card__biz-line-icon": {
    "width": "0.32rem",
    "height": "0.32rem"
  }
};



  module.exports = _styles;
  